import {MDCTextField} from '@material/textfield'

new MDCTextField(document.getElementById('password').parentElement)